<template>
  <div class="card">
    <!-- <div class="card-header">
      <div class="row">
        <div class="col-md-8">
          <strong class="card-title mb-3">S1 (S)</strong>
        </div>
        <div class="col-md-3">
          <download :tableId="'s1s'" :fileName="'s1s'"></download>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>-->
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-9 br">
          <!-- <filters @filter="filtData" :filterOptions="filterOptions"></filters> -->
          <!-- <filters @filter="filtData" :sectorData="sectorList" :pType="type"></filters> -->
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <datepicker
                  :input-class="'form-control'"
                  :format="'dd-MM-yyyy'"
                  v-model="ddate"
                  @selected="getDateData($event)"
                ></datepicker>
              </div>
            </div>
            <div class="col-md-3" v-if="searchData.length>0">
              <div class="form-group">
                <select class="form-control" v-model="selFilter" name="raw-data-columns">
                  <option
                    v-for="(d, index) in filterOptions"
                    v-bind:key="d.id+index"
                    :value="d.id"
                    disabled="disabled"
                  >{{d.value}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-2" v-if="searchData.length>0">
              <div class="form-group">
                <!-- <label class="form-label">Max</label> -->
                <input class="form-control" v-model="minRange" placeholder="Min" />
              </div>
            </div>
            <div class="col-md-2" v-if="searchData.length>0">
              <div class="form-group">
                <!-- <label class="form-label">Max</label> -->
                <input class="form-control" v-model="maxRange" placeholder="Max" />
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <select class="form-control" name="sector" v-model="sectorname" @change="getS1Data">
                  <option value>Select Sector</option>
                  <option
                    v-for="(sec, index) in sectorData"
                    :value="sec.sect_name"
                    v-bind:key="sec.sect_code+index"
                    readonly
                  >{{sec.sect_name}}</option>
                </select>
              </div>
            </div>

            <div class="col-md-1" v-if="searchData.length>0">
              <div class="form-group">
                <button @click="filtData" class="btn btn-sm btn-primary" type="button">
                  <i class="fa fa-filter" title="Filter"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <input
              class="form-control"
              v-model="searchText"
              placeholder="Search"
              @keyup="filteredList($event)"
            />
          </div>
        </div>
      </div>
      <!-- <div class="row mt-15">
        <div class="col-md-12">
          <pagination
            ref="page"
            :pageName="type"
            :totPages="totalPages"
            :apiUrl="rawDataApi"
            @changePage="pageChange"
          ></pagination>
        </div>
      </div>-->
      <div class="row mt-15">
        <div class="col-md-12">
          <!-- <pagination
            ref="page"
            :pageName="type"
            :totPages="totalPages"
            :apiUrl="rawDataApi"
            @changePage="pageChange"
          ></pagination>-->
          <div class="pull-right">
            <ul v-if="totalPages != 1" class="pagination">
              <li :class="{disabled:prevDisabled}" class="page-item">
                <a class="page-link" @click.prevent="goToPage(1)" href="#">{{'&lt;&lt;'}}</a>
              </li>
              <li :class="{disabled:prevDisabled}" class="page-item">
                <a class="page-link" @click.prevent="prev()" href="#">{{'&lt;'}}</a>
              </li>
              <li
                v-for="page in pages"
                v-bind:key="page"
                class="page-item"
                :class="(current_page == page)? 'active':''"
              >
                <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
              </li>
              <li :class="{disabled:nextDisabled}" class="page-item">
                <a class="page-link" href="#" @click.prevent="next()">{{'&gt;'}}</a>
              </li>
              <li :class="{disabled:nextDisabled}" class="page-item">
                <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">{{'&gt;&gt;'}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="table-responsive mb-15 app" v-dragscroll="true">
        <table id="return-analysis" class="table table-bordered app-inner" style="font-size: 11px;">
          <thead v-if="tableFields.length>0">
            <tr>
              <th>Sr.</th>
              <th
                @click="sortDynamicColumn(field, index)"
                style="font-size:.92em"
                class="data-cell column-sort"
                v-for="(field, index, key) in tableFields"
                v-bind:key="'field'+field+index+key"
              >
                {{field.name}}
                <span v-if="field.isSortable && sortIndex === index">
                  <i class="fa fa-caret-down" v-if="(field.sort === 1)"></i>
                  <i class="fa fa-caret-up" v-else-if="(field.sort === -1)"></i>
                </span>
              </th>
            </tr>
          </thead>
          <tbody v-if="tableFields.length>0">
            <tr v-for="(row, index, key) in rawData" v-bind:key="'row'+row+index">
              <td>{{(parseInt(page)===1)? (index+1):(((parseInt(page)-1)*perPage)+(index+1))}}</td>
              <td v-for="(field, ind) in tableFields" v-bind:key="ind+'-td-'+index+key">
                <span
                  v-if="field.title === 'sector_name' || field.title === 'co_code' || field.title === 'name' || field.title === 'market_capitalization' || field.title === title"
                >
                  <span v-if="field.isLink">
                    <a class="a-btn" @click.prevent="showCompDetails(row)">{{ row[field.title]}}</a>
                  </span>
                  <span
                    v-else
                  >{{(field.isNumeric)? getChecknFixed(row[field.title]): row[field.title]}}</span>
                </span>
                <span v-else>
                  <span
                    v-if="row['data']"
                  >{{(field.isNumeric)? getChecknFixed(row['data'][field.title]): row['data'][field.title]}}</span>
                </span>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="rawData.length===0">
            <tr>
              <td :colspan="tableFields.length">
                <div class="alert alert-danger" role="alert">No data found!</div>
              </td>
            </tr>
          </tfoot>
        </table>
        <!-- <div class="alert alert-danger" role="alert" v-else>No data found!</div> -->
      </div>
      <div class="row mt-15">
        <div class="col-md-5"></div>
        <div class="col-md-1" v-if="searchData.length>0">
          <download :tableId="'return-analysis'" :fileName="'return-analysis'"></download>
        </div>
        <div class="col-md-6">
          <!-- <pagination
            ref="page"
            :pageName="type"
            :totPages="totalPages"
            :apiUrl="rawDataApi"
            @changePage="pageChange"
          ></pagination>-->
          <div class="pull-right">
            <ul v-if="totalPages != 1" class="pagination">
              <li :class="{disabled:prevDisabled}" class="page-item">
                <a class="page-link" @click.prevent="goToPage(1)" href="#">{{'&lt;&lt;'}}</a>
              </li>
              <li :class="{disabled:prevDisabled}" class="page-item">
                <a class="page-link" @click.prevent="prev()" href="#">{{'&lt;'}}</a>
              </li>
              <li
                v-for="page in pages"
                v-bind:key="page"
                class="page-item"
                :class="(current_page == page)? 'active':''"
              >
                <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
              </li>
              <li :class="{disabled:nextDisabled}" class="page-item">
                <a class="page-link" href="#" @click.prevent="next()">{{'&gt;'}}</a>
              </li>
              <li :class="{disabled:nextDisabled}" class="page-item">
                <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">{{'&gt;&gt;'}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { pCommonMixins } from "../../assets/mixins/pcommon.js";
import Datepicker from "vuejs-datepicker";

export default {
  components: { Datepicker },
  mixins: [commonMixins, pCommonMixins],
  props: ["sectorList", "mcFilter", "title"],
  created() {
    //console.log('ddate::3', this.ddate, new Date().setDate(new Date().getDate() - 1));    
    this.getS1Data();
  },
  data() {
    return {
      ddate: new Date().setDate(new Date().getDate() - 1),
      tableFields: [],
      rawDataApi: "getReturnAnalysis",
      apiUrl: "",
      rawData: {},
      searchData: [],
      searchText: "",
      curYear: new Date().getFullYear(),
      minRange: "",
      maxRange: "",
      filterOptions: [
        {
          id: "",
          value: "Select",
          isNumeric: true,
          sort_order: 0
        }
      ],
      selFilter: "",
      selRangeFilter: 0,
      type: "return-analysis",
      sectorData: [],
      sectorname: "",
      page: 1,
      perPage: 700,
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: [],
      actTab: 22,
      sort_param: "",
      s_order: 1,
      sortIndex: 4
    };
  },
  methods: {
    getS1Data() {
      this.rawData = [];
      let myself = this;
      let data = {};
      data = {
        my_date: myself.getDate(myself.ddate),
        sector: myself.sectorname,
        m_filter: this.selFilter,
        min_range: this.minRange,
        max_range: this.maxRange,
        pageid: myself.page,
        sort_param: this.sort_param,
        s_order: this.s_order
      };
      // console.log("POST DATA", data);
      http.post(myself.rawDataApi, data, (error, response) => {
        if (response.data.length > 0) {
          // console.log("Data");
          if (this.page === 0) {
            this.page = 1;
          } else {
            myself.rawData = response.data; //.slice(0, 500);
            myself.searchData = response.data; //.slice(0, 500);
            myself.ddate = myself.rawData[0].date
              ? new Date(myself.rawData[0].date)
              : myself.ddate;
            
            if(myself.ddate == "Invalid Date"){
              myself.ddate = new Date(myself.fixDate(myself.rawData[0].date));
            } 
            //console.log('ddate::42', myself.ddate);

            myself.totalPages = response.total_pages ? response.total_pages : 1;
            let i = 8;
            let page = myself.current_page - 2;
            if (page <= 0) page = 1;
            myself.pages = [];
            while (i) {
              myself.pages.push(parseInt(page));
              if (myself.totalPages <= page) break;
              page++;
              i--;
            }
            if (this.rawData.length > 0) {
              this.filterOptions = [
                {
                  id: "",
                  value: "Select",
                  isNumeric: true,
                  sort_order: 1
                }
              ];
              var tblFields = Object.keys(this.rawData[0]);
              this.tableFields = [];
              tblFields.forEach((val, key) => {
                if (val !== "date" && val !== "_id") {
                  if (val === "data") {
                    var raCols = Object.keys(this.rawData[0][val]);
                    raCols.forEach((value, k) => {
                      // if(this.tableFields.length<50){
                      this.tableFields.push({
                        title: value,
                        name: this.getCustomLabel(value)
                          ? this.getCustomLabel(value)
                          : this.getLabel(value),
                        isNumeric:
                          typeof this.rawData[0][value] === "string"
                            ? false
                            : true,
                        sort: this.s_order,
                        sort_order: 6,
                        isLink: 0,
                        isSortable: 1
                      });
                      // }
                    });
                  } else {
                    this.tableFields.push({
                      title: val,
                      name: this.getCustomLabel(val)
                        ? this.getCustomLabel(val)
                        : this.getLabel(val),
                      isNumeric:
                        val === "co_code" ||
                        val === "name" ||
                        val === "sector_name"
                          ? false
                          : true,
                      sort:
                        val === "co_code"
                          ? 1
                          : val === "name"
                          ? 2
                          : val === "market_capitalization"
                          ? 4
                          : val === "sector_name"
                          ? 3
                          : 5,
                      sort_order:
                        val === "co_code"
                          ? 1
                          : val === "name"
                          ? 2
                          : val === "market_capitalization"
                          ? 4
                          : val === "sector_name"
                          ? 3
                          : 5,
                      isLink: val === "name" ? 1 : 0,
                      isSortable: 0
                    });
                  }
                }
                if (
                  val !== "co_code" &&
                  val !== "_id" &&
                  val !== "date" &&
                  val !== "name" &&
                  val !== "sector_name"
                ) {
                  if (val === "data") {
                    var raCols = Object.keys(this.rawData[0][val]);
                    raCols.forEach((valuee, k) => {
                      this.filterOptions.push({
                        id: valuee,
                        value: this.getCustomLabel(valuee)
                          ? this.getCustomLabel(valuee)
                          : this.getLabel(valuee),
                        isNumeric: true,
                        sort_order: valuee === "market_capitalization" ? 1 : 2
                      });
                    });
                  } else {
                    this.filterOptions.push({
                      id: val,
                      value: this.getCustomLabel(val)
                        ? this.getCustomLabel(val)
                        : this.getLabel(val),
                      isNumeric: true,
                      sort_order: val === "market_capitalization" ? 1 : 2
                    });
                  }
                }
              });
              this.tableFields = this.sorted_fields_asc(
                this.tableFields,
                "sort_order"
              );
              // console.log("Table fields", this.tabs[this.actTab].title, this.tableFields, this.filterOptions);
            }
            console.log("tableFields", this.tableFields);
            console.log("filterOptions", this.filterOptions);
          }
        }
      });
    },
    pageChange(data) {
      this.page = data.page ? data.page : 1;
      this.getS1Data();
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.prevDisabled = 0;
      this.fillTable();
    },
    fillTable() {
      this.page = this.pageToLoad;
      if (this.pageToLoad == this.totalPages) {
        this.nextDisabled = 1;
      } else {
        this.nextDisabled = 0;
      }
      if (this.pageToLoad == 1) {
        this.prevDisabled = 1;
      } else {
        this.prevDisabled = 0;
      }
      this.current_page = this.pageToLoad;
      this.getS1Data();
    },
    filtData(obj) {
      this.page = 1;
      this.getS1Data();
    },
    filterRangeData(event) {
      this.clearData();
      var ind = event.target.value;
      this.selRangeFilter = this.mcOptions[ind].id;
      if (this.selRangeFilter === 0) {
        this.rawData = this.searchData;
        return this.rawData;
      } else {
        var minRange = this.mcOptions[ind].min;
        var maxRange = this.mcOptions[ind].max;
        this.rawData = this.searchData.filter(rd => {
          // console.log(
          //   rd.market_capitalization,
          //   this.selRangeFilter,
          //   minRange,
          //   maxRange
          // );
          if (minRange != "" && maxRange != "") {
            return (
              parseInt(rd["market_capitalization"]) >= parseInt(minRange) &&
              parseInt(rd["market_capitalization"]) <= parseInt(maxRange)
            );
          } else {
            if (minRange != "") {
              return (
                parseInt(rd["market_capitalization"]) >= parseInt(minRange)
              );
            }
            if (maxRange != "") {
              return (
                parseInt(rd["market_capitalization"]) <= parseInt(maxRange)
              );
            }
          }
        });
      }
      setTimeout(() => {
        this.sortColumn(this.tableFields[2], 2);
      });
    },
    filteredList(e) {
      this.selRangeFilter = 0;
      this.selFilter = "";
      if (this.searchText === null || this.searchText === "") {
        this.rawData = this.searchData;
        return this.rawData;
      } else if (this.searchText.length <= 2) {
        this.rawData = this.searchData;
        return this.rawData;
      }
      if (this.searchText.length > 2 || e.keyCode === 13) {
        this.rawData = this.searchData.filter(rd => {
          return (
            rd.co_code.toLowerCase().includes(this.searchText.toLowerCase()) ||
            (rd.name
              ? rd.name.toLowerCase().includes(this.searchText.toLowerCase())
              : false)
          );
        });
      }
    },
    clearData() {
      this.selRangeFilter = 0;
      this.selFilter = "";
      this.sectorname = "";
      this.searchText = "";
      this.sectorname = "";
      this.searchText = "";
      this.selFilter[2] = "p11_quarterly_trends";
      this.ddate = new Date().setDate(new Date().getDate() - 1);
      //console.log('ddate::1', this.ddate);
      this.minRange[0] = this.minRange[1] = this.minRange[2] = this.maxRange[0] = this.maxRange[1] = this.maxRange[2] =
        "";
      this.rawData = this.searchData;
    },
    getDateData(e) {
      console.log("Date Selected", e);
      this.ddate = e;
      //console.log('ddate::2', this.ddate);
      this.getS1Data();
    },
    sortDynamicColumn(field, ind) {
      console.log(field, ind, this.tableFields[ind].sort);
      this.tableFields[ind].sort =
        field.sort === -1 ? 1 : field.sort === 1 ? -1 : 1;
      // this.s_order = this.s_order === -1 ? 1 : this.s_order === 1 ? -1 : 1;
      this.sortIndex = ind;
      this.sort_param = this.tableFields[ind].title;
      // this.tableFields[ind].sort = this.s_order;
      this.s_order = this.tableFields[ind].sort;
      console.log(field, ind, this.tableFields[ind].sort);
      this.getS1Data();
    }
  },
  watch: {
    sectorList(value) {
      this.sectorData = value;
    }
  },
  computed: {
    filterOptions0: function() {
      return this.filterOptions.filter(function(row, index) {
        return row.id === "p11_actual";
      });
    },
    filterOptions1: function() {
      return this.filterOptions.filter(function(row, index) {
        return row.id === "q1_a_b_greater";
      });
    },
    filterOptions2: function() {
      return this.filterOptions.filter(function(row, index) {
        return row.id === "p11_quarterly_trends";
        // return row.id === "q1_S" || row.id === "q1_a_S" || row.id === "q1_b_S" || row.id === "q1_c_S" || row.id === "q1_d_S";
      });
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/market-data/return-analysis.vue